import React, { useCallback, useEffect, useMemo, useState } from "react";
import LayoutComponent from "../../components/shared/Layout";
import SubCasino from "./SubCasino";
import GameCard from "../../components/GameCard";
import {
  gamesLiveArray,
  hotGameData,
  SportsGameData,
} from "../../constraints/constants";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { compact, head, isEmpty, startCase } from "lodash";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { Fishing, LiveCasino, Poker, Slot } from "../casinoList";
import { useInfiniteScroll } from "../../components/useInfiniteScroll";
import { FaSearch } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
const Casino = (props) => {
  const PAGE_SIZE = 25;

  const COLLECTION = {
    slot: Slot,
    live: LiveCasino,
    fishing: Fishing,
    poker: Poker,
    hotgame: hotGameData,
    sports: SportsGameData,
  };

  const COLLECTION_Name = {
    slot: "Slot",
    live: "Live Casino",
    fishing: "Fishing",
    poker: "Poker",
    hotgame: "Hot Games",
    sports: "Sports Games",
  };

  const getAllItems = () =>
    Object.values(COLLECTION).flatMap((col) => Object.values(col).flat());

  const getFilteredItems = (collection, subCasino) => {
    if (!collection) return [];
    const isAll = !subCasino || subCasino === "all";
    return isAll
      ? Object.values(collection).flat()
      : (collection[subCasino] ?? []);
  };

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const amounutRefresh = useContextSelector(
    AuthContext,
    (ctx) => ctx.amounutRefresh,
  );
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);

  const [header, setHeader] = useState("live");
  const [subCasino, setSubCasino] = useState("all");
  const [input, setInput] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (!isEmpty(user)) amounutRefresh();
  }, [user]);

  useEffect(() => {
    const h = searchParams.get("header") ?? "";
    const s = searchParams.get("subCasino") ?? "";
    setHeader(h);
    setSubCasino(s);
  }, [searchParams]);

  const filteredList = useMemo(() => {
    if (!isEmpty(input)) {
      const search = input.toLowerCase().trim();
      return getAllItems().filter((res) =>
        res?.name?.toLowerCase().includes(search),
      );
    }

    if (!header) return [];
    const collection = COLLECTION[header];
    return getFilteredItems(collection, subCasino);
  }, [header, subCasino, input]);

  useEffect(() => {
    setPage(1);
  }, [filteredList]);

  const visibleItems = useMemo(
    () => filteredList.slice(0, page * PAGE_SIZE),
    [filteredList, page],
  );

  const hasMore = visibleItems.length < filteredList.length;
  const loadMore = useCallback(() => setPage((p) => p + 1), []);

  const loaderRef = useInfiniteScroll(loadMore, hasMore);
  return (
    <div>
      <LayoutComponent visibilityType={true}>
        <div className="main-casino-wrapper" style={{ padding: "0" }}>
          {" "}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              color: "rgb(255 184 0 / 1)",
              background: "rgb(21 81 85 / 1)",
              padding: "10px",
            }}
          >
            <svg
              onClick={() => navigate("/")}
              style={{
                position: "absolute",
                left: "10px",
                fontSize: "26px",
                color: "rgb(255 184 0 / 1)",
              }}
              stroke="currentColor"
              fill="currentColor"
              strokeWidth={0}
              viewBox="0 0 512 512"
              className="text-[#ffb800] absolute top-1/2 -translate-y-1/2 left-1 cursor-pointer text-[26px] w-16"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.7-.7 33.1L310.9 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z" />
            </svg>
            <div
              style={{ fontSize: "19px" }}
              className="w-full text-[#ffb800] text-[19px] text-center font-bold"
            >
              {COLLECTION_Name[header]}
            </div>
          </div>
          {!["sports", "livecasino", "hotgame"].includes(header) ? (
            <SubCasino
              header={header}
              setSubCasino={setSubCasino}
              subCasino={subCasino}
            />
          ) : (
            ""
          )}
          {!["sports", "livecasino", "hotgame"].includes(header) && (
            <div
              style={{ margin: "13px", marginTop: "0" }}
              className="flex items-center justify-between bg-[#002632] rounded-md px-4 py-2 vendor-menu-scroll text-white text-white"
            >
              <input
                placeholder="Game Name"
                className="w-full outline-none bg-transparent placeholder:text-[#23FFC8]"
                type="text"
                onChange={(e) => setInput(e.target.value)}
                value={input}
                style={{ width: "100%" }}
              />
              {!isEmpty(input) && (
                <RxCross2
                  style={{ marginRight: "4px" }}
                  onClick={() => {
                    setInput("");
                  }}
                  size={20}
                  color="#006165"
                />
              )}
              <FaSearch size={20} color="#006165" />
            </div>
          )}
          {visibleItems?.length > 0 && (
            <div className="games-card-inner">
              <div className="row">
                {visibleItems?.map((res, index) => {
                  return <GameCard key={index} res={res} />;
                })}
              </div>
            </div>
          )}
          {hasMore && (
            <div ref={loaderRef} className="list-loading ng-star-inserted" />
          )}
        </div>
      </LayoutComponent>
    </div>
  );
};

export default Casino;
